import React from 'react';
import { CheckIcon, XIcon, MinusIcon } from 'lucide-react';
import { comparisonColumns, comparisonRows, Rating } from '../data/comparison';
export function ComparisonSection() {
  return <section id="vergleich" className="py-16 lg:py-28 bg-[#0d1225] scroll-mt-16" data-id="element-45" data-mp="39ehfvg6jt506">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46" data-mp="34fo4pueqhq36">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 lg:mb-16 items-end" data-id="element-47" data-mp="34f4vd235ga0r">
          <div className="lg:col-span-7" data-id="element-48" data-mp="2zhmix1pxbco0">
            <h2 className="text-3xl lg:text-5xl font-bold text-white mb-5" data-id="element-49" data-mp="2ze8ihz0tldj7">
              Close CRM Agenturen im Vergleich: Es gibt einen Sweet Spot
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed" data-id="element-50" data-mp="2qgoietep1na6">
              Die einen skalieren so stark, dass sie ihre Umsetzung nicht mehr
              im Griff haben. Die anderen haben vor ein, zwei Jahren angefangen
              und noch nicht die Erfahrung für wirklich gute Systeme.
            </p>
          </div>
          <p className="lg:col-span-5 text-sm text-gray-500 leading-relaxed lg:text-right" data-id="element-51" data-mp="jncibhr53os9">
            Natürlich sind wir hier voreingenommen. Prüf diese Punkte bei jedem
            Anbieter – auch bei uns.
          </p>
        </div>

        <div className="overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0" data-id="element-52" data-mp="30hgh5koui9y7">
          <table className="w-full min-w-[760px] border-separate border-spacing-0 text-left" data-id="element-53" data-mp="30j9rpb2kxebh">
            <caption className="sr-only" data-id="element-54" data-mp="35hurj9dx5vze">
              Vergleich von Close CRM Agenturtypen
            </caption>
            <thead data-id="element-55" data-mp="1zb6aqtnrqe3">
              <tr data-id="element-56" data-mp="1zt4hszvseon">
                <th scope="col" className="w-[28%] pb-5 pr-4 align-bottom text-sm font-medium text-gray-500" data-id="element-57" data-mp="1y9n1z2hnxla">
                  Kriterium
                </th>
                {comparisonColumns.map(col => {
                const highlight = col.id === 'kraft';
                return <th key={col.id} scope="col" className={`w-[24%] px-5 pt-5 pb-5 align-bottom ${highlight ? 'bg-[#ff6b35]/10 border-x border-t border-[#ff6b35]/30 rounded-t-2xl' : ''}`} data-id="element-58" data-mp="fy14k9s7rw41">
                      <span className={`block text-lg font-bold ${highlight ? 'text-[#ff6b35]' : 'text-white'}`} data-id="element-59" data-mp="kn267ctkclo1">
                        {col.label}
                      </span>
                      <span className="block text-sm font-normal text-gray-500 mt-1" data-id="element-60" data-mp="bmx159budzd1">
                        {col.note}
                      </span>
                    </th>;
              })}
              </tr>
            </thead>
            <tbody data-id="element-61" data-mp="1xvkdgxh3dy0">
              {comparisonRows.map((row, rowIndex) => {
              const isLast = rowIndex === comparisonRows.length - 1;
              return <tr key={row.criterion} data-id="element-62" data-mp="3p2biy58tfv9z" data-mpi={rowIndex}>
                    <th scope="row" className="py-4 pr-4 border-t border-white/5 font-medium text-gray-200 align-top" data-id="element-63" data-mp="3p10c1wk2q7en">
                      {row.criterion}
                    </th>
                    {row.values.map((cell, i) => {
                  const highlight = comparisonColumns[i].id === 'kraft';
                  return <td key={i} className={`px-5 py-4 border-t align-top ${highlight ? `bg-[#ff6b35]/10 border-x border-[#ff6b35]/30 ${isLast ? 'border-b rounded-b-2xl' : ''}` : 'border-white/5'}`} style={highlight ? {
                    borderTopColor: 'rgba(255,107,53,0.15)'
                  } : undefined} data-id="element-64" data-mp="28j9q17j5jkz3" data-mpi={i}>
                          <span className="flex gap-3" data-id="element-65" data-mp="x5fp5xswok3y">
                            <RatingIcon rating={cell.rating} data-id="element-66" data-mp="125acxshdwtks" />
                            <span className={highlight ? 'text-white' : 'text-gray-400'} data-id="element-67" data-mp="123h90ky5ongh">
                              {cell.text}
                            </span>
                          </span>
                        </td>;
                })}
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}
function RatingIcon({
  rating
}: {
  rating: Rating;
}) {
  if (rating === 'good') {
    return <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" aria-label="erfüllt" data-id="element-68" data-mp="3ngvuth2h9ne4" />;
  }
  if (rating === 'bad') {
    return <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" aria-label="nicht erfüllt" data-id="element-69" data-mp="3ilqd6ug3yuvu" />;
  }
  return <MinusIcon className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" aria-label="teilweise" data-id="element-70" data-mp="3shjvkugidilj" />;
}